// ============================================================
// FILE: scholarships/index.js
// PURPOSE: Lazy loading - sirf selected scholarship load hogi
// IDs scholarships array ke IDs se bilkul match hongi
// ============================================================

const scholarshipData = {
  cheveningScholarship:          () => import('./chevening'),
  daadScholarship:               () => import('./daad'),
  fulbrightScholarship:          () => import('./fulbright'),
  australiaAwardsScholarship:    () => import('./australia'),
  erasmusScholarship:            () => import('./erasmus'),
  cscScholarship:                () => import('./csc'),
  swedishInstituteScholarship:   () => import('./si'),
  commonwealthScholarship:       () => import('./commonwealth'),
  turkiyeBurslariScholarship:    () => import('./turkiye'),
  gatesCambridgeScholarship:     () => import('./gates-cambridge'),
  kaustScholarship:              () => import('./kaust'),
  knightHennessyScholarship:     () => import('./knight-hennessy'),
  mextScholarship:               () => import('./mext'),
  rhodesScholarship:             () => import('./rhodes'),
  stipendiumHungaricumScholarship: () => import('./stipendium'),
  swissGovernmentExcellenceScholarship: () => import('./swissGovernmentExcellence'),
};

export default scholarshipData;